<button 
  [class]="buttonClasses"
  [disabled]="disabled || loading"
  (click)="onClick($event)"
  type="button">
  
  <!-- Loading Spinner -->
  <i-lucide [name]="'loader-2'" [class]="iconSize + ' animate-spin -ml-1 mr-2'" *ngIf="loading"></i-lucide>

  <!-- Left Icon -->
  <ng-container *ngIf="icon && iconPosition === 'left' && !loading">
    <i-lucide [name]="icon" [class]="iconSize + ' mr-2'"></i-lucide>
    <!-- <check-icon *ngSwitchCase="'check'" [class]="iconSize + ' mr-2'"></check-icon>
    <arrow-right-icon *ngSwitchCase="'arrow-right'" [class]="iconSize + ' mr-2'"></arrow-right-icon>
    <arrow-left-icon *ngSwitchCase="'arrow-left'" [class]="iconSize + ' mr-2'"></arrow-left-icon>
    <send-icon *ngSwitchCase="'send'" [class]="iconSize + ' mr-2'"></send-icon>
    <plus-icon *ngSwitchCase="'plus'" [class]="iconSize + ' mr-2'"></plus-icon>
    <download-icon *ngSwitchCase="'download'" [class]="iconSize + ' mr-2'"></download-icon>
    <upload-icon *ngSwitchCase="'upload'" [class]="iconSize + ' mr-2'"></upload-icon>
    <trash-icon *ngSwitchCase="'trash'" [class]="iconSize + ' mr-2'"></trash-icon>
    <edit-icon *ngSwitchCase="'edit'" [class]="iconSize + ' mr-2'"></edit-icon>
    <save-icon *ngSwitchCase="'save'" [class]="iconSize + ' mr-2'"></save-icon>
    <search-icon *ngSwitchCase="'search'" [class]="iconSize + ' mr-2'"></search-icon>
    <x-icon *ngSwitchCase="'x'" [class]="iconSize + ' mr-2'"></x-icon>
    <external-link-icon *ngSwitchCase="'external-link'" [class]="iconSize + ' mr-2'"></external-link-icon>
    <refresh-cw-icon *ngSwitchCase="'refresh'" [class]="iconSize + ' mr-2'"></refresh-cw-icon> -->
  </ng-container>

  <!-- Button Content -->
  <span 
    [class.opacity-0]="loading"
    class="transition-opacity duration-200">
    <ng-content></ng-content>
  </span>

  <!-- Right Icon -->
  <ng-container *ngIf="icon && iconPosition === 'right' && !loading">
    <i-lucide [name]="icon" [class]="iconSize + ' ml-2'"></i-lucide>
    <!-- <check-icon *ngSwitchCase="'check'" [class]="iconSize + ' ml-2'"></check-icon>
    <arrow-right-icon *ngSwitchCase="'arrow-right'" [class]="iconSize + ' ml-2'"></arrow-right-icon>
    <arrow-left-icon *ngSwitchCase="'arrow-left'" [class]="iconSize + ' ml-2'"></arrow-left-icon>
    <send-icon *ngSwitchCase="'send'" [class]="iconSize + ' ml-2'"></send-icon>
    <plus-icon *ngSwitchCase="'plus'" [class]="iconSize + ' ml-2'"></plus-icon>
    <download-icon *ngSwitchCase="'download'" [class]="iconSize + ' ml-2'"></download-icon>
    <upload-icon *ngSwitchCase="'upload'" [class]="iconSize + ' ml-2'"></upload-icon>
    <trash-icon *ngSwitchCase="'trash'" [class]="iconSize + ' ml-2'"></trash-icon>
    <edit-icon *ngSwitchCase="'edit'" [class]="iconSize + ' ml-2'"></edit-icon>
    <save-icon *ngSwitchCase="'save'" [class]="iconSize + ' ml-2'"></save-icon>
    <search-icon *ngSwitchCase="'search'" [class]="iconSize + ' ml-2'"></search-icon>
    <x-icon *ngSwitchCase="'x'" [class]="iconSize + ' ml-2'"></x-icon>
    <external-link-icon *ngSwitchCase="'external-link'" [class]="iconSize + ' ml-2'"></external-link-icon>
    <refresh-cw-icon *ngSwitchCase="'refresh'" [class]="iconSize + ' ml-2'"></refresh-cw-icon> -->
  </ng-container>
</button> 